import { IntlShape, createIntl, createIntlCache } from 'react-intl'

import { APP_LOCALE_FALLBACK } from './constants'

const cache = createIntlCache()

export function createAppIntl(
  locale: string,
  messages: Record<string, string>,
) {
  return createIntl({ locale, messages, textComponent: 'span' }, cache)
}

let intl: IntlShape = createAppIntl(APP_LOCALE_FALLBACK, {})

export function updateIntl(locale: string, messages: Record<string, string>) {
  intl = createAppIntl(locale, messages)

  return intl
}

export const getIntl = () => intl
